module.exports = __webpack_public_path__ + "img/eric-lassen-signature.ac6da248.png";